import styled, { css } from 'styled-components';
import { getColor, typeScale, StyleVars } from 'core/utils';
import { resetBtn, align } from 'styled-manila';

const isIn = status => status === 'entered' || status === 'exited';

export const Background = styled.div`
	background-color: ${({ backgroundColor }) => backgroundColor || getColor("lavender")};
	color: ${({ textColor }) => textColor || getColor("white")};
	transition: ${({ delay }) => delay }ms;

	${({ status } ) => !isIn(status) && css`
		height: 0;
	`}
`;

export const Container = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: ${StyleVars.screenCjDesktopMd};
	margin-left: auto;
	margin-right: auto;
`;

export const Cta = styled.a`
	color: inherit;
	text-align: center;
	font-weight: 600;
	margin: 0;
	padding: ${typeScale(1.5)} ${typeScale(3)};
	max-width: 90%;
	text-decoration: none;
	line-height: 1.2;
	&:hover, &:active, &:focus {
		color: inherit;
	}

	strong {
		text-decoration: underline;
		font-style: normal;
	}
`;

export const CloseButton = styled.button`
	${resetBtn};
	${align("vertical")};

	right: 0;
	z-index: 1;
	display: block;
	padding: ${typeScale(1.5)} ${typeScale(2)};

	span {
		display: none;
	}
`;
